module.exports = __webpack_public_path__ + "img/120.e4020409.jpg";